var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { client, serverErrorMessage } from './client';
import { checkGameImageSize } from '../utils/img';
/**
 * Build the CRUD wrappers for one image family.
 *
 * @param kind  URL segment under /images, e.g. 'dialogue-images'
 * @param label Human-readable noun used in console error messages, e.g. 'dialogue'
 */
export function createImageApi(kind, label) {
    const base = `/images/${kind}`;
    return {
        upload(data) {
            return __awaiter(this, void 0, void 0, function* () {
                try {
                    // Reject an off-size image before spending the upload; the server
                    // enforces the same rule, this just answers the author immediately.
                    const sizeProblem = yield checkGameImageSize(kind, data.file);
                    if (sizeProblem)
                        return { success: false, error: sizeProblem };
                    const formData = new FormData();
                    formData.append('file', data.file);
                    formData.append('levelId', data.levelId.toString());
                    return yield client.post(base, formData, {
                        headers: { 'Content-Type': 'multipart/form-data' },
                    });
                }
                catch (err) {
                    console.error(`Error uploading ${label} image`, err);
                    return { success: false, error: serverErrorMessage(err, 'Upload failed') };
                }
            });
        },
        list(levelId) {
            return __awaiter(this, void 0, void 0, function* () {
                try {
                    return yield client.get(`${base}/${levelId}`);
                }
                catch (err) {
                    console.error(`Error fetching ${label} images`, err);
                    return [];
                }
            });
        },
        listArchived(levelId) {
            return __awaiter(this, void 0, void 0, function* () {
                try {
                    return yield client.get(`${base}/${levelId}/archived`);
                }
                catch (err) {
                    console.error(`Error fetching archived ${label} images`, err);
                    return [];
                }
            });
        },
        archive(id) {
            return __awaiter(this, void 0, void 0, function* () {
                yield client.delete(`${base}/${id}`);
            });
        },
        restore(id) {
            return __awaiter(this, void 0, void 0, function* () {
                yield client.patch(`${base}/${id}/restore`, {});
            });
        },
        deletePermanent(id) {
            return __awaiter(this, void 0, void 0, function* () {
                yield client.delete(`${base}/${id}/permanent`);
            });
        },
    };
}
